import MasterWallet from "../pages/MasterWallet/MasterWallet";

const MasterWalletRoutes = [
  { path: "asc-wallet/master-wallet", element: <MasterWallet /> },
];

export default MasterWalletRoutes;
